"use client";

import { useState } from "react";
import { Play, X } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheFutureOfHomecareSafety() {
  const [isDemoOpen, setIsDemoOpen] = useState(false);
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const words = [{
    text: "MEDICATION",
    italic: false,
    accent: false
  }, {
    text: "MANAGEMENT",
    italic: false,
    accent: false
  }, {
    text: "REIMAGINED.",
    italic: true,
    accent: true
  }];
  return <section data-section-id="4596" id="the-future-of-homecare-safety" className="bg-background text-foreground relative overflow-hidden min-h-screen sm:h-screen w-full">
      <div className="relative grid grid-cols-1 lg:grid-cols-12 h-full w-full">
        <div ref={leftRef} className="lg:col-span-5 relative z-20 flex flex-col justify-center px-5 sm:px-8 lg:px-14 py-20 lg:py-0">
          

          <h1 className="font-default font-bold leading-[0.9] mb-6" style={{
          fontSize: "clamp(1.75rem, 5vw, 4.5rem)",
          letterSpacing: "-0.05em"
        }}>
            {words.map((w, i) => <span key={i} data-index={i} className="block overflow-hidden transition-all duration-1000 opacity-100 translate-y-0 !text-[45px]" style={{
            transitionDelay: `${200 + i * 150}ms`,
            color: w.accent ? "var(--primary)" : undefined,
            fontSize: w.accent ? "0.85em" : undefined
          }}>
                {w.text}
              </span>)}
          </h1>

          <p className="font-serif font-light leading-relaxed max-w-[38ch] mb-10 text-muted-foreground transition-all duration-700 delay-700 opacity-100 translate-y-0 !text-xl">
            Eliminate the stress of daily pill sorting. Our automated MedaCube dispenser ensures accuracy, safety, and peace of mind for every caregiver.
          </p>

          <div className={`flex flex-col sm:flex-row gap-4 transition-all duration-700 delay-[900ms] ${leftVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
            <Link to="/Contact">
              <Button size="lg" className="h-12 px-7 font-mono text-xs tracking-[0.18em] font-medium shadow-lg hover:opacity-90 rounded-md" style={{
              backgroundColor: "var(--primary)",
              color: "var(--primary-foreground)"
            }}>
                REQUEST A CONSULTATION →
              </Button>
            </Link>
            <Button variant="ghost" size="lg" onClick={() => setIsDemoOpen(true)} className="h-12 px-7 font-mono text-xs tracking-[0.18em] font-medium border border-border hover:bg-secondary rounded-md">
              <Play className="size-3 fill-current" />
              WATCH THE DEMO
            </Button>
          </div>

          <div className={`hidden lg:flex absolute bottom-10 left-14 items-center gap-3 font-mono text-[10px] tracking-[0.3em] text-muted-foreground transition-opacity duration-1000 delay-[1200ms] ${leftVisible ? "opacity-100" : "opacity-0"}`}>
            
          </div>
        </div>

        <div ref={rightRef} className="lg:col-span-7 relative overflow-hidden min-h-[400px] lg:min-h-0">
          <div className="absolute inset-0 overflow-hidden">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703060/img/Add-Smart-Medication-Management.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703060/img/Add-Smart-Medication-Management.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703060/img/Add-Smart-Medication-Management.png-wvc-sizes" alt="MedaCube medication dispenser in a modern home setting" loading="lazy" decoding="async" className="w-full h-full object-cover thread-kenburns !text-[rgba(25,22,29,1)] !opacity-[0.6]" style={{
            filter: "saturate(0.9) contrast(1.05)"
          }} src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703060/img/Add-Medication-Adherance-1.png" src="https://seniorlivinginsights.com/wp-content/uploads/2026/06/Add-Medication-Adherance-1.webp" />
            <div className="absolute inset-0 pointer-events-none" style={{
            background: "linear-gradient(90deg, var(--background) 0%, transparent 25%, transparent 75%, hsla(0,0%,0%,0.1) 100%)"
          }} />
          </div>

        </div>
      </div>

      {}
      {isDemoOpen && <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
          <div className="absolute inset-0 bg-black/80 backdrop-blur-sm transition-opacity duration-300" onClick={() => setIsDemoOpen(false)} />
          <div className="relative w-full max-w-5xl aspect-video bg-black rounded-lg overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-300">
            <Button variant="ghost" size="icon" onClick={() => setIsDemoOpen(false)} className="absolute top-4 right-4 z-10 text-white hover:bg-white/20 rounded-md">
              <X className="size-6" />
            </Button>
            <iframe src="https://player.vimeo.com/video/555834182?autoplay=1" className="w-full h-full" allow="autoplay; fullscreen; picture-in-picture" allowFullScreen title="MedaCube Demo Video" />
          </div>
        </div>}

      <style>{`
        @keyframes thread-kenburns {
          0% { transform: scale(1); }
          100% { transform: scale(1.04); }
        }
        .thread-kenburns {
          animation: thread-kenburns 20s ease-out forwards;
        }
      `}</style>
    </section>;
}